/**
 * License Inventory Content Component
 * Displays license inventory table and findings panel side by side
 */

import React from 'react';

import Findings from '../Findings/Findings';
import LicenseInventory from '../LicenseInventory/LicenseInventory';

import type { LicenseInventoryContentProps } from './type';

import './LicenseInventoryContent.css';

/**
 * License Inventory Content component displaying inventory and findings
 */
function LicenseInventoryContent({
  onSelectLicense,
}: LicenseInventoryContentProps): React.ReactElement {
  const handleSelectLicense = (licenseId: string): void => {
    onSelectLicense?.(licenseId);
  };

  return (
    <div className='licenseInventoryContent'>
      <div className='licenseInventoryContentMain'>
        <LicenseInventory onSelectLicense={handleSelectLicense} />
      </div>
      <div className='licenseInventoryContentSidebar'>
        <Findings />
      </div>
    </div>
  );
}

export default LicenseInventoryContent;
